import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Merchants from './screens/merchants';
import DashboardLayout from './components/dashboardLayout/main';
import Login from './screens/login';
import AuthLayout from './components/authLayout/main';
import ResetPassword from './screens/resetPassword';
import ForgotPassword from './screens/forgotPassword';
import Dashboard from './screens/dashboard';
import TransactionLog from './screens/transactionLog';
import ApiKey from './screens/apiKey';
import AddMerchant from './screens/addMerchant';
import CreditMerchant from './screens/creditMerchant';
import ViewMerchant from './screens/viewMerchant';
import SMSCredit from './screens/smsCredit';
import NetworkLookUp from './screens/networkLookUp';
import SendSmS from './screens/sendSms';
import ErrorPage from './screens/errorPage';
import UnauthorizedPage from './components/errorPage/unauthorized';
import EditMerchant from './screens/editMerchant';
import ProtectRoute from './utils/protectedRoute';
import User from './screens/user';
import AddUser from './screens/addUser';
import ViewUser from './screens/viewUser';
import EditUser from './screens/editUser';
import TransactionReport from './screens/transactionReport';
import ViewSenderId from './screens/senderId';
import ViewBillingConfiguration from './screens/billingConfiguration';
import AddBillingConfiguration from './screens/addBillingConfiguraion';
import AddSenderId from './screens/addSenderId';
import EditSenderId from './screens/editSendId';
import EditBillingConfiguration from './screens/editBillingConfiguration';

function App() {
	return (
		<Router>
			<Routes>
				<Route
					path='/merchants'
					element={
						<ProtectRoute allowedRoles={['ADMIN']}>
							<DashboardLayout>
								<Merchants />
							</DashboardLayout>
						</ProtectRoute>
					}
				/>

				<Route
					path='/users/:merchantName/:Id'
					element={
						<ProtectRoute allowedRoles={['ADMIN']}>
							<DashboardLayout>
								<User />
							</DashboardLayout>
						</ProtectRoute>
					}
				/>
				<Route
					path='/merchants/addSenderId/:merchantName/:Id'
					element={
						<ProtectRoute allowedRoles={['ADMIN']}>
							<DashboardLayout>
								<AddSenderId />
							</DashboardLayout>
						</ProtectRoute>
					}
				/>
				<Route
					path='/merchants/editSenderId/:merchantName/:id/:userId'
					element={
						<ProtectRoute allowedRoles={['ADMIN']}>
							<DashboardLayout>
								<EditSenderId />
							</DashboardLayout>
						</ProtectRoute>
					}
				/>
				<Route
					path='/merchants/addBillingConfiguration/:merchantName/:Id'
					element={
						<ProtectRoute allowedRoles={['ADMIN']}>
							<DashboardLayout>
								<AddBillingConfiguration />
							</DashboardLayout>
						</ProtectRoute>
					}
				/>
				<Route
					path='/merchants/editBillingConfiguration/:merchantName/:Id/:network/:promotionalCost/:transactionalCost'
					element={
						<ProtectRoute allowedRoles={['ADMIN']}>
							<DashboardLayout>
								<EditBillingConfiguration />
							</DashboardLayout>
						</ProtectRoute>
					}
				/>
				<Route
					path='/merchants/senderId/:merchantName/:Id'
					element={
						<ProtectRoute allowedRoles={['ADMIN']}>
							<DashboardLayout>
								<ViewSenderId />
							</DashboardLayout>
						</ProtectRoute>
					}
				/>

				<Route
					path='/merchants/billingConfiguration/:merchantName/:Id'
					element={
						<ProtectRoute allowedRoles={['ADMIN']}>
							<DashboardLayout>
								<ViewBillingConfiguration />
							</DashboardLayout>
						</ProtectRoute>
					}
				/>

				<Route path='*' element={<ErrorPage />} />
				<Route path='/unauthorized' element={<UnauthorizedPage />} />
				<Route
					path='/'
					element={
						<AuthLayout>
							<Login />
						</AuthLayout>
					}
				/>
				<Route
					path='/reset-password'
					element={
						<AuthLayout>
							<ResetPassword />
						</AuthLayout>
					}
				/>
				<Route
					path='/forgot-password'
					element={
						<AuthLayout>
							<ForgotPassword />
						</AuthLayout>
					}
				/>
				<Route
					path='/dashboard'
					element={
						<DashboardLayout>
							<Dashboard />
						</DashboardLayout>
					}
				/>
				<Route
					path='/'
					element={
						<AuthLayout>
							<Login />
						</AuthLayout>
					}
				/>
				<Route
					path='/transaction-log'
					element={
						<DashboardLayout>
							<TransactionLog />
						</DashboardLayout>
					}
				/>
				<Route
					path='/transaction-report'
					element={
						<DashboardLayout>
							<TransactionReport />
						</DashboardLayout>
					}
				/>
				<Route
					path='/apikey'
					element={
						<DashboardLayout>
							<ApiKey />
						</DashboardLayout>
					}
				/>
				<Route
					path='/sms-credit'
					element={
						<DashboardLayout>
							<SMSCredit />
						</DashboardLayout>
					}
				/>

				<Route
					path='/merchants/add'
					element={
						<DashboardLayout>
							<AddMerchant />
						</DashboardLayout>
					}
				/>
				<Route
					path='/merchants/credit/:Id'
					element={
						<DashboardLayout>
							<CreditMerchant />
						</DashboardLayout>
					}
				/>
				<Route
					path='/merchants/view/:Id'
					element={
						<DashboardLayout>
							<ViewMerchant />
						</DashboardLayout>
					}
				/>

				<Route
					path='/merchants/edit/:Id'
					element={
						<DashboardLayout>
							<EditMerchant />
						</DashboardLayout>
					}
				/>

				<Route
					path='/users/edit/:Id'
					element={
						<DashboardLayout>
							<EditUser />
						</DashboardLayout>
					}
				/>

				<Route
					path='/users/view/:Id'
					element={
						<DashboardLayout>
							<ViewUser />
						</DashboardLayout>
					}
				/>

				<Route
					path='/users/add/:merchantId'
					element={
						<DashboardLayout>
							<AddUser />
						</DashboardLayout>
					}
				/>
				{/* <Route
          path="/merchants/edit"
          element={
            <DashboardLayout>
              <EditMerchant />
            </DashboardLayout>
          }
        /> */}
				<Route
					path='/network-lookup'
					element={
						<DashboardLayout>
							<NetworkLookUp />
						</DashboardLayout>
					}
				/>

				<Route
					path='/send-sms'
					element={
						<DashboardLayout>
							<SendSmS />
						</DashboardLayout>
					}
				/>
			</Routes>
		</Router>
	);
}

export default App;
